import { render, staticRenderFns } from "./centerBottom.vue?vue&type=template&id=86e84c9a&scoped=true"
import script from "./centerBottom.vue?vue&type=script&lang=js"
export * from "./centerBottom.vue?vue&type=script&lang=js"
import style0 from "./centerBottom.vue?vue&type=style&index=0&id=86e84c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e84c9a",
  null
  
)

export default component.exports